/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import LayoutWithSidebarNav from '../../shared/components/Layout/LayoutWithSidebarNav';
import AccountSettings from './components/presentational/account-settings';
import CommunicationSettings from './components/presentational/communication-settings';
import SingleSignOn from './components/presentational/single-sign-on';
import OrganizationSettings from './components/presentational/organization-settings';
import IntegrationSettings from './components/presentational/integrations-settings';
import SubscriptionSettings from './components/presentational/subscriptions-settings';
import ManageCookies from './components/presentational/manage-cookies';
import NotificationSettings from './components/presentational/notification-settings';
import { generalSettingsSideBarNavArrayOfObjects } from '../../shared/constants';
import {
  getOrganizationSettings,
  getNotificationSettings,
  getNotificationTypes,
  fetchCommunicationSettings,
} from '../login/ducks/loginActions';
import Text from '../../shared/_TBComponents/Text';
import Spinner from '../../shared/_TBComponents/Spinner';

const HELMET_TEXT = 'Settings';
const NAV_LINK_ARRAY_OF_OBJECTS = generalSettingsSideBarNavArrayOfObjects;

const PageTitleContainer = styled('div')`
  text-align: ${({ containerWidth }) => (containerWidth && containerWidth < 400 ? 'center' : 'start')};
  padding-bottom: 30px;
`;

const SpinnerWrapper = styled('div')`
  display: flex;
  height: 100vh;
`;

const Settings = () => {
  const dispatch = useDispatch();
  const [containerWidth, setContainerWidth] = useState(null);

  const isMeLoading = useSelector((state) => state.auth.ui.isLoginLoading);

  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const {
    accountCode,
    primaryAdmin,
    admin,
    organizationResellerAccountEnabled,
    resellerSubscriptions,
  } = currentUser || {};

  useEffect(() => {
    if (accountCode && primaryAdmin) {
      dispatch(getOrganizationSettings(accountCode));
    }
  }, [accountCode, primaryAdmin]);

  useEffect(() => {
    batch(() => {
      dispatch(getNotificationSettings());
      dispatch(getNotificationTypes());
      dispatch(fetchCommunicationSettings());
    });
  }, []);

  return (
    <LayoutWithSidebarNav
      helmetText={HELMET_TEXT}
      navLinkArrayOfObjects={NAV_LINK_ARRAY_OF_OBJECTS}
      sideBarTitle='Settings'
      sideBarTitleIcon='settings'
    >
      {isMeLoading ? (
        <SpinnerWrapper>
          <Spinner large />
        </SpinnerWrapper>
      ) : (
        <>
          <ResizeObserver
            onResize={(rect) => {
              setContainerWidth(rect.width);
            }}
          />
          <PageTitleContainer containerWidth={containerWidth}>
            <Text
              styledTextProps={{
                fontSize: containerWidth && containerWidth < 400 ? 28 : 34,
                fontWeight: '400',
              }}
            >
              General Settings
            </Text>
          </PageTitleContainer>
          <AccountSettings />
          {/* Changed from shorthand to complete ternary so that React doesn't render a 0 on the page when reading false */}
          {primaryAdmin > 0 ? <OrganizationSettings /> : null}
          {!admin
          && (organizationResellerAccountEnabled
            || (resellerSubscriptions && resellerSubscriptions.length)) ? (
              <SubscriptionSettings />
            ) : null}
          {primaryAdmin > 0 ? <IntegrationSettings /> : null}
          {!admin ? (
            <CommunicationSettings containerWidth={containerWidth} />
          ) : null}
          <NotificationSettings containerWidth={containerWidth} />
          <SingleSignOn containerWidth={containerWidth} />
          <ManageCookies containerWidth={containerWidth} />
        </>
      )}
    </LayoutWithSidebarNav>
  );
};

export default Settings;
